import FacebookRoundedIcon from "@mui/icons-material/FacebookRounded";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import SearchIcon from "@mui/icons-material/Search";
import YouTubeIcon from "@mui/icons-material/YouTube";
import {
  Box,
  Button,
  CircularProgress,
  Divider,
  IconButton,
  Card,
  InputBase,
  Paper,
  Typography,
  Grid,
  Avatar,
  Rating,
  CardContent,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  List,
  ListItem,
  ListItemText,
} from "@mui/material";
import React from "react";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";

import ReadOnlyQuill from "../../components/Backend/Admin/Posts/ReadOnlyQuill";
import Layout from "../../components/Layout/Frontend/Layout";
import { FetchRecordingCourseFrontendDetailAsync } from "../../redux/thunk/RecordingCourse";
import PlayCircleIcon from "@mui/icons-material/PlayCircle";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ListIcon from "@mui/icons-material/List";
import VideoLibraryIcon from "@mui/icons-material/VideoLibrary";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import LanguageOutlinedIcon from "@mui/icons-material/LanguageOutlined";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import { ListItemIcon } from "@mui/material";
import CheckIcon from "@mui/icons-material/CheckCircle";
import "./Blog.css";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import { Navigation } from "swiper/modules";
import { setPath } from "../../redux/slice/PathSlice";
import { getCookie } from "../../Utils/GetCookies";
import swal from "sweetalert";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { DateRangeIcon } from "@mui/x-date-pickers";

const students = [
  {
    name: "John Doe",
    review:
      "Excellent in English Proficiency - Reading, Speaking, Writing, Listening.",
    image: "https://via.placeholder.com/150",
    rating: 5,
  },
  {
    name: "Jane Smith",
    review: "Achieved high scores in English proficiency tests.",
    image: "https://via.placeholder.com/150",
    rating: 4.5,
  },
  {
    name: "Jane Smith",
    review: "Achieved high scores in English proficiency tests.",
    image: "https://via.placeholder.com/150",
    rating: 4.5,
  },
  {
    name: "Jane Smith",
    review: "Achieved high scores in English proficiency tests.",
    image: "https://via.placeholder.com/150",
    rating: 4.5,
  },
  {
    name: "Jane Smith",
    review: "Achieved high scores in English proficiency tests.",
    image: "https://via.placeholder.com/150",
    rating: 4.5,
  },
];

const StudentCarousel = () => {
  return (
    <Box sx={{ maxWidth: "80%", margin: "auto", textAlign: "center", py: 4 }}>
      <Typography variant="h5" fontWeight="bold" mb={2}>
        High Score Achiever Students
      </Typography>
      <Swiper
        modules={[Navigation]}
        navigation
        spaceBetween={20}
        slidesPerView={2}
        loop={true}
      >
        {students.map((student, index) => (
          <SwiperSlide key={index}>
            <Card sx={{ p: 2, boxShadow: 3 }}>
              <CardContent>
                <Box display="flex" alignItems="center" gap={2}>
                  <Avatar src={student.image} />
                  <Typography fontWeight="bold">{student.name}</Typography>
                  <Rating value={student.rating} readOnly />
                </Box>
                <Typography variant="body2" mt={2}>
                  {student.review}
                </Typography>
              </CardContent>
            </Card>
          </SwiperSlide>
        ))}
      </Swiper>
    </Box>
  );
};

function RecordingCourse() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const {
    recordingCourseFrontendDetail,
    recordingCourseFrontendDetailStatus,
    buyStatus,
  } = useSelector((state) => state.recordingCourse);

  const userId = localStorage.getItem("userId")
    ? localStorage.getItem("userId")
    : null;
  const rcId = useParams();
  console.log("Param : rcId ", rcId);
  console.log("Param : userId ", userId);
  console.log("Param : Detail Status", recordingCourseFrontendDetailStatus);
  console.log("Param : BuySataus", buyStatus);
  // console.log("Dispatch : ", dispatch.arguments);
  const country = localStorage.getItem("country") || "USD";

  useEffect(() => {
    dispatch(
      FetchRecordingCourseFrontendDetailAsync({
        path: "recording-course-frontend",
        id: rcId.id,
        userID: userId,
      })
    );
  }, [dispatch, rcId]);

  const [isPlaying, setIsPlaying] = useState(true);
  const [expanded, setExpanded] = useState(false);
  const navigation = useNavigate();

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  // Parse modules data from JSON string
  const modules = recordingCourseFrontendDetail.modules
    ? JSON.parse(recordingCourseFrontendDetail.modules)
    : [];

  const clickBuyHandler = () => {
    const userToken = getCookie("userToken");
    let userId = localStorage.getItem("userId");
    if (userId === null || userToken === null) {
      swal({
        title: "Warning",
        text: "You are not logged in",
        icon: "warning",
        button: "OK!",
        closeOnClickOutside: false,
      }).then(() => {
        localStorage.setItem("prevURL", "/subscription");
        navigation("/login/");
      });
    }

    dispatch(setPath());
    navigate("/recording-course/form", {
      state: {
        plan: recordingCourseFrontendDetail,
      },
    });
  };

  let calculateFees = (country, oversea_fees) => {
    const conversionRates = {
      USD: 0.67,
      SGD: 0.9,
      THB: 24.63,
      NZD: 1.09,
    };

    return conversionRates[country]
      ? (oversea_fees * conversionRates[country]).toFixed(2)
      : oversea_fees;
  };

  return (
    <Layout speaking="Recording Course">
      <Box sx={{ bgcolor: "rgb(231 239 254)", p: 2 }}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-evenly",
            background: "whitesmoke",
            borderRadius: "1rem",
            width: "90%",
            mx: "auto",
            p: 0,
          }}
        >
          {recordingCourseFrontendDetailStatus === "succeeded" && (
            <>
              <Box sx={{ width: "60%" }}>
                <Box sx={{ my: 2, p: 2 }}>
                  <Typography variant="h5" fontWeight="bold">
                    {recordingCourseFrontendDetail.title}
                  </Typography>
                  <Typography variant="body1" sx={{ mt: 1 }}>
                    {recordingCourseFrontendDetail.sub_title}
                  </Typography>
                  <Typography variant="body1" sx={{ mt: 1 }}>
                    {recordingCourseFrontendDetail.instructor_info}
                  </Typography>
                  <Typography variant="body1" fontWeight="bold" sx={{ mt: 1 }}>
                    <DateRangeIcon
                      sx={{
                        fontSize: "medium",
                        mr: 0.5,
                      }}
                    />{" "}
                    Last Updated {recordingCourseFrontendDetail.last_update_at}{" "}
                    <LanguageOutlinedIcon
                      sx={{
                        fontSize: "medium",
                        mx: 0.5,
                      }}
                    />{" "}
                    {recordingCourseFrontendDetail.language}
                  </Typography>
                </Box>

                <Box
                  sx={{
                    position: "relative",
                    width: "100%",
                    // height: "400px",
                    backgroundColor: "black",
                    borderRadius: 2,
                    overflow: "hidden",
                    border: "1px solid blue",
                  }}
                >
                  {isPlaying ? (
                    <video
                      width="100%"
                      height="100%"
                      controls
                      autoPlay
                      style={{ borderRadius: 8 }}
                    >
                      <source
                        src={
                          process.env.REACT_APP_BACKEND_URL +
                          "storage/" +
                          recordingCourseFrontendDetail.video_file
                        }
                        type="video/mp4"
                      />
                      Your browser does not support the video tag.
                    </video>
                  ) : (
                    <Box
                      sx={{
                        width: "100%",
                        height: "100%",
                        backgroundImage: `url('${process.env.REACT_APP_BACKEND_URL}storage/${recordingCourseFrontendDetail.vd_thumbnail}')`,
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        cursor: "pointer",
                      }}
                      onClick={() => setIsPlaying(true)}
                    >
                      <Button
                        sx={{
                          backgroundColor: "rgba(0,0,0,0.6)",
                          borderRadius: "50%",
                          p: 2,
                          "&:hover": { backgroundColor: "rgba(0,0,0,0.8)" },
                        }}
                      >
                        <PlayCircleIcon sx={{ fontSize: 60, color: "white" }} />
                      </Button>
                    </Box>
                  )}
                </Box>

                {/* <Card sx={{ my: 3, p: 2 }}>
                <Typography variant="h5" fontWeight="bold">What you'll learn:</Typography>
                <Grid container spacing={2}>
                  <Grid item xs={6}>
                    <List>
                      <ListItem>
                        <ListItemIcon>
                          <CheckIcon color="primary" />
                        </ListItemIcon>
                        <ListItemText primary="10 scored section mock tests - 7 Reading & 3 Listening" />
                      </ListItem>
                      <ListItem>
                        <ListItemIcon>
                          <CheckIcon color="primary" />
                        </ListItemIcon>
                        <ListItemText primary="Experienced Trainer with 5+ years of experience" />
                      </ListItem>
                      <ListItem>
                        <ListItemIcon>
                          <CheckIcon color="primary" />
                        </ListItemIcon>
                        <ListItemText primary="Monthly Prediction File based on past exam patterns" />
                      </ListItem>
                    </List>
                  </Grid>
                  <Grid item xs={6}>
                    <List>
                      <ListItem>
                        <ListItemIcon>
                          <CheckIcon color="primary" />
                        </ListItemIcon>
                        <ListItemText primary="Quizzes after every video to reinforce concepts" />
                      </ListItem>
                      <ListItem>
                        <ListItemIcon>
                          <CheckIcon color="primary" />
                        </ListItemIcon>
                        <ListItemText primary="Coaching for all modules of PTE" />
                      </ListItem>
                    </List>
                  </Grid>
                </Grid>
              </Card> */}

                <Card sx={{ my: 3, p: 2 }}>
                  <Typography variant="h5" fontWeight="bold">
                    What you'll learn
                  </Typography>
                  {recordingCourseFrontendDetail.your_learn && (
                    <Grid container spacing={2}>
                      {/* First column */}
                      <Grid item xs={6}>
                        <List>
                          {JSON.parse(recordingCourseFrontendDetail.your_learn)
                            .slice(
                              0,
                              Math.ceil(
                                JSON.parse(
                                  recordingCourseFrontendDetail.your_learn
                                ).length / 2
                              )
                            )
                            .map((item, index) => (
                              <ListItem key={index}>
                                <ListItemIcon>
                                  <CheckIcon color="primary" />
                                </ListItemIcon>
                                <ListItemText primary={item} />
                              </ListItem>
                            ))}
                        </List>
                      </Grid>

                      {/* Second column */}
                      <Grid item xs={6}>
                        <List>
                          {JSON.parse(recordingCourseFrontendDetail.your_learn)
                            .slice(
                              Math.ceil(
                                JSON.parse(
                                  recordingCourseFrontendDetail.your_learn
                                ).length / 2
                              )
                            )
                            .map((item, index) => (
                              <ListItem key={index}>
                                <ListItemIcon>
                                  <CheckIcon color="primary" />
                                </ListItemIcon>
                                <ListItemText primary={item} />
                              </ListItem>
                            ))}
                        </List>
                      </Grid>
                    </Grid>
                  )}
                </Card>

                {/* Course Content with Dynamic Modules */}
                <Card sx={{ mb: 3, p: 2 }}>
                  <Typography variant="h5" fontWeight="bold" sx={{ pb: 2 }}>
                    Course Content
                  </Typography>
                  <Typography variant="body2" sx={{ pb: 2 }}>
                    {recordingCourseFrontendDetail.course_content}
                  </Typography>
                  {modules.map((module, index) => (
                    <Accordion
                      key={index}
                      expanded={expanded === `module-${index}`}
                      onChange={handleChange(`module-${index}`)}
                      sx={{ mt: 2 }}
                    >
                      <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        sx={{
                          bgcolor:
                            expanded === `module-${index}`
                              ? "#0050ff"
                              : "white",
                          color:
                            expanded === `module-${index}`
                              ? "white"
                              : "inherit",
                          transition: "background-color 0.3s ease",
                          borderRadius: 1,
                          "& .MuiAccordionSummary-content": {
                            // Target the content container
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            width: "100%",
                          },
                        }}
                      >
                        {/* Left-aligned title */}
                        <Typography fontWeight={"bold"}>
                          {module.title}
                        </Typography>

                        {/* Right-aligned hours (placed before expand icon) */}
                        <Typography fontWeight={"bold"} sx={{ mr: 1 }}>
                          {module.totalHours}
                        </Typography>
                      </AccordionSummary>
                      <AccordionDetails>
                        <List>
                          {module.items.map((item, itemIndex) => (
                            <Box
                              key={itemIndex}
                              sx={{
                                display: "flex",
                                alignItems: "center", // Vertically center items
                                width: "100%",
                                paddingLeft: "10px",
                              }}
                            >
                              {/* Left side: PlayIcon + Name */}
                              <Box
                                sx={{
                                  display: "flex",
                                  alignItems: "center",
                                  flexGrow: 1,
                                }}
                              >
                                <ListItemIcon>
                                  <PlayCircleIcon color="primary" />
                                </ListItemIcon>
                                <Typography
                                  component="span"
                                  sx={{ paddingRight: "10px" }}
                                >
                                  {item.name}
                                </Typography>
                              </Box>

                              {/* Right side: Hours (bold) */}
                              <Typography>{item.hour} </Typography>
                            </Box>
                          ))}
                        </List>
                      </AccordionDetails>
                    </Accordion>
                  ))}
                </Card>

                {recordingCourseFrontendDetail !== undefined && (
                  <>
                    <Box
                      sx={{
                        p: 2,
                        mb: 2,
                        textAlign: "center",
                        bgcolor: "white",
                        boxShadow: "0px 3px 10px rgba(7, 7, 7, 0.2)", // Blue-tinted shadow
                        borderRadius: "4px",
                      }}
                    >
                      <Typography
                        variant="h5"
                        fontWeight="bold"
                        sx={{ pb: 2, textAlign: "left" }}
                      >
                        Requirements
                      </Typography>
                      <Box
                        sx={{
                          bgcolor: "white",
                          boxShadow: "0px 3px 10px rgba(7, 7, 7, 0.2)", // Blue-tinted shadow
                          borderRadius: "4px", // Optional: rounded corners
                        }}
                      >
                        <ReadOnlyQuill
                          delta={recordingCourseFrontendDetail.requirement}
                          quillClass={"front-rc"}
                        />
                      </Box>
                    </Box>

                    <Box
                      sx={{
                        mb: 3,
                        p: 2,
                        textAlign: "center",
                        bgcolor: "white",
                        boxShadow: "0px 3px 10px rgba(7, 7, 7, 0.2)", // Blue-tinted shadow
                        borderRadius: "4px",
                      }}
                    >
                      <Typography
                        variant="h5"
                        fontWeight="bold"
                        sx={{ pb: 2, textAlign: "left" }}
                      >
                        Description
                      </Typography>
                      <Box
                        sx={{
                          bgcolor: "white",
                          boxShadow: "0px 3px 10px rgba(7, 7, 7, 0.2)", // Blue-tinted shadow
                          borderRadius: "4px", // Optional: rounded corners
                        }}
                      >
                        <ReadOnlyQuill
                          delta={recordingCourseFrontendDetail.description}
                          quillClass={"front-rc"}
                        />
                      </Box>
                    </Box>
                  </>
                )}

                {/* <StudentCarousel />  */}
              </Box>

              <Box sx={{ width: "40%", p: 2 }}>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "flex-end", // Aligns the content to the end of the row
                    alignItems: "center", // Ensures vertical alignment
                    width: "100%", // Ensures it spans the full row width
                    mb: 2, // Adds some margin at the bottom
                  }}
                >
                  <Button
                    onClick={() => navigate("/recording-course")}
                    sx={{
                      background: "#1976d2",
                      "&:hover": { background: "gray" },
                    }}
                    variant="contained"
                  >
                    <ArrowBackIcon sx={{ color: "black" }} />
                  </Button>
                </Box>

                <Box
                  sx={{
                    maxWidth: 345,
                    mx: "auto",
                  }}
                >
                  <Box
                    sx={{
                      p: 1,
                      borderRadius: 2,
                      width: "fit-content", // Shrink to fit text
                      mt: 17,
                      mb: 1, // Add horizontal margin
                      backgroundColor: "rgb(210 230 255)",
                    }}
                  >
                    <Typography color="blue">
                      PTE Score Booster Tactics
                    </Typography>
                  </Box>

                  <Typography variant="h6">
                    Buy this Video Course with
                  </Typography>
                  <Box
                    sx={{
                      my: 1,
                    }}
                  >
                    <Typography variant="h6" fontWeight="bold" color="blue">
                      {country == "MMK"
                        ? recordingCourseFrontendDetail.fees
                        : calculateFees(
                            country,
                            recordingCourseFrontendDetail.oversea_fees
                          )}{" "}
                      {country}
                    </Typography>
                  </Box>
                </Box>

                <Card
                  sx={{
                    maxWidth: 380,
                    p: 2,
                    borderRadius: 3,
                    boxShadow: 3,
                    mx: "auto",
                    backgroundColor: "rgb(210 230 255)",
                    //  backgroundColor: "rgb(231 239 254)"
                  }}
                >
                  <CardContent>
                    <Box
                      sx={{
                        mt: 0,
                        borderRadius: 3,
                        overflow: "hidden",
                      }}
                    >
                      <ReadOnlyQuill
                        delta={recordingCourseFrontendDetail.course_includes}
                        quillClass={"front-rc"}
                      />
                    </Box>
                  </CardContent>
                  {
                    // Debug first (outside the ternary)
                    console.log("Buy status:", buyStatus)
                  }
                  <Box display="flex" justifyContent="center">
                    {buyStatus === false ? (
                      <Button
                        variant="contained"
                        size="medium"
                        sx={{
                          p: 1.5,
                          px: 6,
                          borderRadius: 2,
                          "&:hover": {
                            backgroundColor: "primary.main", // explicit hover
                          },
                        }}
                        onClick={clickBuyHandler} // no arrow function needed
                      >
                        Buy Now
                      </Button>
                    ) : (
                      <Button
                        variant="contained"
                        //disabled
                        size="medium"
                        sx={{
                          p: 1.5,
                          px: 6,
                          borderRadius: 2,
                          opacity: 0.5, // better visual feedback
                        }}
                        onClick={() =>
                          (window.location.href =
                            "https://ismartacademy.aigmapte.com/login/index.php")
                        }
                      >
                        Go To Course
                      </Button>
                    )}
                  </Box>
                </Card>
              </Box>
            </>
          )}

          {recordingCourseFrontendDetailStatus === "failed" && (
            <Box>Failed to get data .Please retry after some times.</Box>
          )}
        </Box>
      </Box>
    </Layout>
  );
}

export default RecordingCourse;
